import * as React from 'react';
import {FieldArray, InjectedFormProps} from 'redux-form';
import {ActivityField} from './components/ActivityField';
import {showErrorMessage} from '../../util/validators';
import {isUndefined} from 'util';
import {IActivities} from '../../data/api/models';

interface IActivityField {
  label: string;
  name: string;
  key: string;
  value ?: any;
}

interface IActivitiesField extends InjectedFormProps {
  name: string;
  fields: IActivityField[];
  activities: IActivities;
  renderDefinition: any;
  i18n: any;
}

export class ActivitiesField extends React.Component<IActivitiesField, any> {
  private getSum() {
    const { activities } = this.props;

    if (isUndefined(activities) || ! activities) {
      return 0;
    }

    return ['intermediary', 'banking', 'realEstate', 'other'].reduce((total, activity) => {
      let value = 0;
      if (activities.hasOwnProperty(activity) &&
        activities[activity].hasOwnProperty('percent') &&
        activities[activity].percent !== ''
      ) {
        value = activities[activity].percent;
      }

      if (value === null) {
        value = 0;
      }

      return parseFloat(total.toString()) + parseFloat(value.toString());
    }, 0);
  }

  public render() {
    return (
      <FieldArray
        name={this.props.name}
        component={ActivityField}
        fields={this.props.fields}
        validate={[
          showErrorMessage(
            this.getSum() !== parseFloat('100'),
            this.props.i18n.quote.validation.activityPercentagesMismatchError,
          ),
        ]}
        {...this.props}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/components/ActivitiesField/index.tsx